export const isAttachmentPath = () => {
  const currentUrl = window.location;
  const isAttachmentPath = currentUrl.pathname.match(/attachments\/.+/);
  return isAttachmentPath;
};
